export default "__VITE_ASSET__DAe75Jj2__"